import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Suspense as _Suspense, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "w-3 mr-2"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mb-2 font-bold" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "The built-in creatives feature has been disabled and will be completely removed soon. All built-in creatives have been converted to external ones and can now be found in the Creatives section.", -1)
const _hoisted_9 = { class: "grid mb-3" }
const _hoisted_10 = { class: "col-12 lg:col-4" }
const _hoisted_11 = {
  key: 0,
  class: "card"
}
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = {
  key: 1,
  class: "card"
}
const _hoisted_14 = { class: "p-fluid" }
const _hoisted_15 = {
  key: 2,
  class: "card"
}
const _hoisted_16 = { class: "p-fluid" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "p-fluid" }
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "p-fluid" }
const _hoisted_21 = {
  key: 3,
  class: "card"
}
const _hoisted_22 = { class: "card-header" }
const _hoisted_23 = { class: "card-title" }
const _hoisted_24 = { class: "p-fluid" }
const _hoisted_25 = { class: "card" }
const _hoisted_26 = { class: "p-fluid" }
const _hoisted_27 = { class: "col-12 lg:col-4" }
const _hoisted_28 = { class: "card" }
const _hoisted_29 = { class: "p-fluid" }
const _hoisted_30 = { class: "card" }
const _hoisted_31 = { class: "p-fluid" }
const _hoisted_32 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_33 = { class: "card" }
const _hoisted_34 = { class: "p-fluid" }
const _hoisted_35 = {
  key: 1,
  class: "card"
}
const _hoisted_36 = { class: "p-fluid" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = { class: "p-fluid" }
const _hoisted_39 = {
  key: 2,
  class: "card"
}
const _hoisted_40 = { class: "p-fluid" }
const _hoisted_41 = {
  key: 3,
  class: "card"
}
const _hoisted_42 = { class: "card-header align-items-center" }
const _hoisted_43 = { class: "card-title" }
const _hoisted_44 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_45 = { class: "p-fluid" }
const _hoisted_46 = { class: "card" }
const _hoisted_47 = { class: "p-fluid" }
const _hoisted_48 = {
  key: 4,
  class: "card"
}
const _hoisted_49 = { class: "card-header" }
const _hoisted_50 = { class: "card-title" }
const _hoisted_51 = { class: "p-fluid" }
const _hoisted_52 = { class: "col-12 lg:col-4" }
const _hoisted_53 = {
  key: 0,
  class: "card"
}
const _hoisted_54 = { class: "card-header" }
const _hoisted_55 = { class: "card-title" }
const _hoisted_56 = { class: "p-fluid" }
const _hoisted_57 = { class: "card" }
const _hoisted_58 = { class: "p-fluid" }
const _hoisted_59 = {
  key: 1,
  class: "card"
}
const _hoisted_60 = { class: "p-fluid" }
const _hoisted_61 = {
  key: 2,
  class: "card"
}
const _hoisted_62 = { class: "p-fluid" }
const _hoisted_63 = {
  key: 3,
  class: "card"
}
const _hoisted_64 = { class: "p-fluid" }
const _hoisted_65 = { class: "grid mb-3" }
const _hoisted_66 = {
  key: 0,
  class: "col-12 lg:col-4"
}
const _hoisted_67 = { class: "card" }
const _hoisted_68 = { class: "p-fluid" }
const _hoisted_69 = { class: "col-12 lg:col-4" }
const _hoisted_70 = { class: "card" }
const _hoisted_71 = { class: "p-fluid" }
const _hoisted_72 = { class: "grid mb-3" }
const _hoisted_73 = { class: "col-12 lg:col-4" }
const _hoisted_74 = { class: "card" }
const _hoisted_75 = { class: "p-fluid" }
const _hoisted_76 = {
  key: 0,
  class: "col-12 lg:col-4"
}
const _hoisted_77 = { class: "card" }
const _hoisted_78 = { class: "p-fluid" }
const _hoisted_79 = {
  key: 1,
  class: "col-12 lg:col-4"
}
const _hoisted_80 = { class: "card" }
const _hoisted_81 = { class: "p-fluid" }
const _hoisted_82 = { class: "col-12 lg:col-4" }
const _hoisted_83 = { class: "card" }
const _hoisted_84 = { class: "p-fluid" }
const _hoisted_85 = { class: "grid mb-2" }
const _hoisted_86 = { class: "col-12 lg:col-6" }
const _hoisted_87 = { class: "col-12 lg:col-6" }
const _hoisted_88 = { class: "col-12 lg:col-4" }
const _hoisted_89 = { class: "card" }
const _hoisted_90 = { class: "p-fluid" }
const _hoisted_91 = {
  key: 0,
  class: "grid mb-3"
}
const _hoisted_92 = { class: "col-12 lg:col-4" }
const _hoisted_93 = { class: "card" }
const _hoisted_94 = { class: "p-fluid" }
const _hoisted_95 = { class: "grid mb-3" }
const _hoisted_96 = { class: "col-12 lg:col-4" }
const _hoisted_97 = { class: "card" }
const _hoisted_98 = { class: "p-fluid" }
const _hoisted_99 = { class: "col-12 lg:col-4" }
const _hoisted_100 = { class: "card" }
const _hoisted_101 = { class: "p-fluid" }
const _hoisted_102 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_103 = { class: "col-12 lg:col-4" }
const _hoisted_104 = { class: "card" }
const _hoisted_105 = { class: "p-fluid" }
const _hoisted_106 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_107 = { class: "grid mb-3" }
const _hoisted_108 = {
  key: 0,
  class: "col-12 lg:col-4"
}
const _hoisted_109 = { class: "card" }
const _hoisted_110 = { class: "p-fluid" }
const _hoisted_111 = { class: "col-12 lg:col-4" }
const _hoisted_112 = { class: "card" }
const _hoisted_113 = { class: "p-fluid" }
const _hoisted_114 = {
  key: 1,
  class: "col-12 lg:col-4"
}
const _hoisted_115 = { class: "card" }
const _hoisted_116 = { class: "p-fluid" }
const _hoisted_117 = { class: "col-12 lg:col-4" }
const _hoisted_118 = { class: "card" }
const _hoisted_119 = { class: "p-fluid" }
const _hoisted_120 = { class: "grid mb-3" }
const _hoisted_121 = { class: "col-12 lg:col-4" }
const _hoisted_122 = { class: "p-fluid" }
const _hoisted_123 = { class: "col-12 lg:col-4" }
const _hoisted_124 = { class: "p-fluid" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("h3", null, "Miscellaneous ℹ️", -1)
const _hoisted_126 = { class: "grid" }
const _hoisted_127 = { class: "col-12 lg:col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueToast = _resolveComponent("PrimeVueToast")!
  const _component_PrimeVueMessage = _resolveComponent("PrimeVueMessage")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldCheckbox = _resolveComponent("FieldCheckbox")!
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_Macros = _resolveComponent("Macros")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_FieldImageBase64Cropper = _resolveComponent("FieldImageBase64Cropper")!
  const _component_FieldImageBase64CropperMultiple = _resolveComponent("FieldImageBase64CropperMultiple")!
  const _component_Creatives = _resolveComponent("Creatives")!
  const _component_FieldBidCPC = _resolveComponent("FieldBidCPC")!
  const _component_FieldBidCPM = _resolveComponent("FieldBidCPM")!
  const _component_CustomBids = _resolveComponent("CustomBids")!
  const _component_FieldNumber = _resolveComponent("FieldNumber")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!
  const _component_FieldListBox = _resolveComponent("FieldListBox")!
  const _component_TargetingByValues = _resolveComponent("TargetingByValues")!
  const _component_ScheduleByHours = _resolveComponent("ScheduleByHours")!
  const _component_ScheduleByDays = _resolveComponent("ScheduleByDays")!
  const _component_AdSecure = _resolveComponent("AdSecure")!
  const _component_Entry = _resolveComponent("Entry")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PrimeVueToast, {
      position: "bottom-right",
      group: "bc"
    }, {
      message: _withCtx(({ message }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(message.detail.compiled_name), 1),
          _createElementVNode("div", _hoisted_3, [
            (message.detail.icon_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "w-full border-round-sm",
                    src: message.detail.icon_url
                  }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(message.detail.title), 1),
              _createElementVNode("div", null, _toDisplayString(message.detail.description), 1)
            ])
          ]),
          (message.detail.image_url)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "block mt-2 w-full border-round-sm",
                src: message.detail.image_url
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_PrimeVueMessage, {
      class: "mb-4",
      severity: "info",
      closable: false
    }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }),
    _createVNode(_component_Entry, {
      title: _ctx.$t('campaign'),
      entry: _ctx.campaign,
      "entry-errors-map": _ctx.campaignErrorsMap,
      "onUpdate:entry-errors-map": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.campaignErrorsMap) = $event)),
      "entry-fetch-handler": _ctx.fetchCampaign,
      "entry-store-handler": _ctx.storeCampaign,
      "href-prefix": "campaigns",
      "on-entry-store-redirect-to-entries": ""
    }, {
      "buttons-col-2-prepend": _withCtx(() => [
        (!!_ctx.campaign.id)
          ? (_openBlock(), _createBlock(_component_PrimeVueButton, {
              key: 0,
              class: "p-button-secondary ml-4 mb-0",
              label: _ctx.$t('clone'),
              icon: "pi pi-copy",
              onClick: _ctx.cloneCampaign
            }, null, 8, ["label", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('common_settings')) + " ⚙️", 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_ctx.campaign.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.campaign.id,
                      label: "ID",
                      disabled: ""
                    }, null, 8, ["model-value"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isSuperAdmin())
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.project_id,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.campaign.project_id) = $event)),
                        _ctx.onProjectChange
                      ],
                      modelModifiers: { number: true },
                      name: "project_id",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('project'),
                      loading: _ctx.projectsLoading,
                      disabled: !!_ctx.campaign.id,
                      options: _ctx.projects.data,
                      "option-value": "id",
                      "option-label": "name"
                    }, null, 8, ["modelValue", "errors-map", "label", "loading", "disabled", "options", "onUpdate:modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.user_id,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.campaign.user_id) = $event)),
                        _ctx.onUserChange
                      ],
                      modelModifiers: { number: true },
                      name: "user_id",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('user'),
                      loading: _ctx.usersLoading,
                      disabled: !!_ctx.campaign.id,
                      options: _ctx.users.data,
                      "option-value": "id",
                      "option-label": "compiled_name",
                      filter: ""
                    }, null, 8, ["modelValue", "errors-map", "label", "loading", "disabled", "options", "onUpdate:modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_FieldText, {
                  modelValue: _ctx.campaign.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.campaign.name) = $event)),
                  modelModifiers: { trim: true },
                  name: "name",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('name')
                }, null, 8, ["modelValue", "errors-map", "label"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.traffic_type,
                  "onUpdate:modelValue": [
                    _cache[3] || (_cache[3] = ($event: any) => ((_ctx.campaign.traffic_type) = $event)),
                    _ctx.onTrafficTypeChange
                  ],
                  modelModifiers: { number: true },
                  name: "traffic_type",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('traffic_type'),
                  disabled: !!_ctx.campaign.id,
                  options: _ctx.trafficTypes
                }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options", "onUpdate:modelValue"]),
                (_ctx.user.isStaff())
                  ? (_openBlock(), _createBlock(_component_FieldCheckbox, {
                      key: 0,
                      modelValue: _ctx.campaign.mix_traffic_type,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.campaign.mix_traffic_type) = $event)),
                      label: _ctx.$t('mix_traffic_type')
                    }, null, 8, ["modelValue", "label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.traffic_category,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.campaign.traffic_category) = $event)),
                  modelModifiers: { number: true },
                  name: "traffic_category",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('traffic_category'),
                  disabled: !!_ctx.campaign.id && _ctx.user.isAffiliate(),
                  options: _ctx.TRAFFIC_CATEGORIES
                }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"]),
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.vertical,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.campaign.vertical) = $event)),
                  modelModifiers: { number: true },
                  name: "vertical",
                  "show-clear": "",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('vertical'),
                  options: _ctx.VERTICALS
                }, null, 8, ["modelValue", "errors-map", "label", "options"])
              ])
            ]),
            (_ctx.isPush || _ctx.isNative)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("h6", null, _toDisplayString(_ctx.$t('creative')) + " 🎨", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.creative_type,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.campaign.creative_type) = $event)),
                      modelModifiers: { number: true },
                      name: "creative_type",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('creative_type'),
                      options: _ctx.CAMPAIGN_CREATIVE_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "errors-map", "label", "options"]),
                    (_ctx.campaign.creative_type === _ctx.CAMPAIGN_CREATIVE_TYPE_BUILTIN)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_FieldText, {
                            modelValue: _ctx.campaign.creative_title,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.campaign.creative_title) = $event)),
                            modelModifiers: { trim: true },
                            name: "creative_title",
                            "errors-map": _ctx.campaignErrorsMap,
                            label: _ctx.$t('title'),
                            help: `${_ctx.$t('max_length')}: 32 ${_ctx.$t('chars')}`
                          }, null, 8, ["modelValue", "errors-map", "label", "help"]),
                          _createVNode(_component_FieldTextarea, {
                            modelValue: _ctx.campaign.creative_description,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.campaign.creative_description) = $event)),
                            modelModifiers: { trim: true },
                            name: "creative_description",
                            "errors-map": _ctx.campaignErrorsMap,
                            label: _ctx.$t('description'),
                            help: `${_ctx.$t('max_length')}: 128 ${_ctx.$t('chars')}`
                          }, null, 8, ["modelValue", "errors-map", "label", "help"]),
                          (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Macros, {
                                class: "my-3",
                                macros: ['city']
                              })
                            ]),
                            fallback: _withCtx(() => [
                              _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                            ]),
                            _: 1
                          })),
                          (_ctx.isPush)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_openBlock(), _createBlock(_Suspense, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FieldImageBase64Cropper, {
                                      modelValue: _ctx.campaign.creative_icon_base64,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.campaign.creative_icon_base64) = $event)),
                                      "image-url": _ctx.campaign.creative_icon_url,
                                      name: "creative_icon_base64",
                                      "errors-map": _ctx.campaignErrorsMap,
                                      label: `${_ctx.$t('icon')} (192x192)`,
                                      "max-width": 128,
                                      "aspect-ratio": 1
                                    }, null, 8, ["modelValue", "image-url", "errors-map", "label"])
                                  ]),
                                  fallback: _withCtx(() => [
                                    _createVNode(_component_PrimeVueSkeleton, { height: "50px" })
                                  ]),
                                  _: 1
                                })),
                                (_openBlock(), _createBlock(_Suspense, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FieldImageBase64Cropper, {
                                      modelValue: _ctx.campaign.creative_image_base64,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.campaign.creative_image_base64) = $event)),
                                      "image-url": _ctx.campaign.creative_image_url,
                                      name: "creative_image_base64",
                                      "errors-map": _ctx.campaignErrorsMap,
                                      label: `${_ctx.$t('image')} (360x240 / 720x480)`,
                                      "max-width": 256,
                                      "aspect-ratio": 3/2
                                    }, null, 8, ["modelValue", "image-url", "errors-map", "label"])
                                  ]),
                                  fallback: _withCtx(() => [
                                    _createVNode(_component_PrimeVueSkeleton, { height: "50px" })
                                  ]),
                                  _: 1
                                }))
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.isNative)
                            ? (_openBlock(), _createBlock(_Suspense, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FieldImageBase64CropperMultiple, {
                                    modelValue: _ctx.campaign.creative_image_native_base64,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.campaign.creative_image_native_base64) = $event)),
                                    "image-url": _ctx.campaign.creative_image_native_url,
                                    name: "creative_image_native_base64",
                                    "errors-map": _ctx.campaignErrorsMap,
                                    label: _ctx.$t('image'),
                                    "max-width": 256,
                                    "aspect-ratios": [_ctx.CREATIVE_IMAGE_ASPECT_RATIO_W1H1, _ctx.CREATIVE_IMAGE_ASPECT_RATIO_W4H3, _ctx.CREATIVE_IMAGE_ASPECT_RATIO_W1D97H1]
                                  }, null, 8, ["modelValue", "image-url", "errors-map", "label", "aspect-ratios"])
                                ]),
                                fallback: _withCtx(() => [
                                  _createVNode(_component_PrimeVueSkeleton, { height: "50px" })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.campaign.creative_type === _ctx.CAMPAIGN_CREATIVE_TYPE_MULTIPLE)
              ? (_openBlock(), _createBlock(_Suspense, { key: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Creatives, {
                      modelValue: _ctx.campaign.creatives,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.campaign.creatives) = $event)),
                      onPreviewCreative: _ctx.previewCreative
                    }, {
                      creative: _withCtx(({ creative }) => [
                        _createVNode(_component_FieldDropdownNext, {
                          modelValue: creative.creative_id,
                          "onUpdate:modelValue": ($event: any) => ((creative.creative_id) = $event),
                          modelModifiers: { number: true },
                          label: _ctx.$t('creative'),
                          loading: _ctx.creativesLoading,
                          options: _ctx.creatives.data,
                          "option-value": "id",
                          "option-label": "compiled_name",
                          filter: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "loading", "options"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onPreviewCreative"])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueSkeleton, { height: "50px" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_FieldTextarea, {
                  modelValue: _ctx.campaign.click_url,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.campaign.click_url) = $event)),
                  modelModifiers: { trim: true },
                  name: "click_url",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('click_url'),
                  help: `${_ctx.$t('max_length')}: 1024 ${_ctx.$t('chars')}`
                }, null, 8, ["modelValue", "errors-map", "label", "help"]),
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Macros, {
                      class: "mt-3",
                      macros: _ctx.macros
                    }, null, 8, ["macros"])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                  ]),
                  _: 1
                }))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.payment_type,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.campaign.payment_type) = $event)),
                  modelModifiers: { number: true },
                  name: "payment_type",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('payment_type'),
                  disabled: !!_ctx.campaign.id,
                  options: _ctx.CAMPAIGN_PAYMENT_TYPES
                }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"])
              ])
            ]),
            (_ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPC)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      (_openBlock(), _createBlock(_component_FieldBidCPC, {
                        key: _ctx.campaign.bid,
                        modelValue: _ctx.campaign.bid,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.campaign.bid) = $event)),
                        modelModifiers: { number: true },
                        name: "bid",
                        "errors-map": _ctx.campaignErrorsMap,
                        help: _ctx.minCpc ? `${_ctx.$t('min')}: ${_ctx.$n(_ctx.minCpc, 'bid')}` : null,
                        min: _ctx.minCpc
                      }, null, 8, ["modelValue", "errors-map", "help", "min"])),
                      (_ctx.campaign.traffic_type === _ctx.TRAFFIC_TYPE_POP)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.campaign.bid > _ctx.CAMPAIGN_TOO_HIGH_BID_POP)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, "⚠️ Make sure the your CPC bid is correct, the specified value is high for the Pop"))
                              : _createCommentVNode("", true),
                            (_openBlock(), _createBlock(_component_FieldBidCPM, {
                              key: _ctx.campaign.bid,
                              modelValue: _ctx.campaign.bid,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.campaign.bid) = $event)),
                              modelModifiers: { number: true },
                              name: "bid",
                              "errors-map": _ctx.campaignErrorsMap,
                              help: _ctx.minCpm ? `${_ctx.$t('min')}: ${_ctx.$n(_ctx.minCpm, 'payout')}` : null,
                              min: _ctx.minCpm
                            }, null, 8, ["modelValue", "errors-map", "help", "min"]))
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_openBlock(), _createBlock(_Suspense, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomBids, {
                        modelValue: _ctx.campaign.bids_by_countries_ids,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.campaign.bids_by_countries_ids) = $event)),
                        title: _ctx.$t('cpc_by_countries'),
                        min: _ctx.minCpc
                      }, {
                        key: _withCtx(({ customBid }) => [
                          _createVNode(_component_FieldDropdownNext, {
                            class: "mb-0",
                            modelValue: customBid.key,
                            "onUpdate:modelValue": ($event: any) => ((customBid.key) = $event),
                            modelModifiers: { number: true },
                            label: _ctx.$t('country'),
                            loading: _ctx.countriesLoading,
                            "show-clear": "",
                            filter: "",
                            options: _ctx.countries.data,
                            "option-value": "id",
                            "option-label": "compiled_name"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "loading", "options"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "title", "min"])
                    ]),
                    fallback: _withCtx(() => [
                      _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                    ]),
                    _: 1
                  })),
                  (_openBlock(), _createBlock(_Suspense, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomBids, {
                        modelValue: _ctx.campaign.bids_by_endpoints_uids,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.campaign.bids_by_endpoints_uids) = $event)),
                        title: _ctx.$t('cpc_by_zones_uids'),
                        min: _ctx.minCpc
                      }, {
                        key: _withCtx(({ customBid }) => [
                          _createVNode(_component_FieldNumber, {
                            class: "mb-0",
                            modelValue: customBid.key,
                            "onUpdate:modelValue": ($event: any) => ((customBid.key) = $event),
                            modelModifiers: { number: true },
                            label: _ctx.$t('zone_uid'),
                            "use-grouping": false
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "title", "min"])
                    ]),
                    fallback: _withCtx(() => [
                      _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                    ]),
                    _: 1
                  })),
                  (_openBlock(), _createBlock(_Suspense, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomBids, {
                        modelValue: _ctx.campaign.bids_by_subids_uuids,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.campaign.bids_by_subids_uuids) = $event)),
                        title: _ctx.$t('cpc_by_subids_uuids'),
                        min: _ctx.minCpc,
                        "key-validator": _ctx.validateUuid
                      }, {
                        key: _withCtx(({ customBid }) => [
                          _createVNode(_component_FieldText, {
                            class: "mb-0",
                            modelValue: customBid.key,
                            "onUpdate:modelValue": ($event: any) => ((customBid.key) = $event),
                            modelModifiers: { trim: true },
                            label: _ctx.$t('subid_uuid')
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "title", "min", "key-validator"])
                    ]),
                    fallback: _withCtx(() => [
                      _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                    ]),
                    _: 1
                  }))
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.campaign.hardcoded_conversion_payout,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.campaign.hardcoded_conversion_payout) = $event)),
                  modelModifiers: { number: true },
                  name: "hardcoded_conversion_payout",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('fixed_conversion_payout'),
                  min: 0,
                  "min-fraction-digits": 1,
                  "max-fraction-digits": 3,
                  prefix: "$"
                }, null, 8, ["modelValue", "errors-map", "label"])
              ])
            ]),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_FieldNumber, {
                      modelValue: _ctx.campaign.revshare,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.campaign.revshare) = $event)),
                      modelModifiers: { number: true },
                      name: "revshare",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('revshare'),
                      min: 1,
                      max: 200,
                      step: 5,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus",
                      suffix: "%"
                    }, null, 8, ["modelValue", "errors-map", "label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.campaign.max_spending_per_day,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.campaign.max_spending_per_day) = $event)),
                  modelModifiers: { number: true },
                  name: "max_spending_per_day",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('max_spending_per_day'),
                  help: _ctx.$t('max_spending_per_day_help'),
                  min: 0,
                  step: 5,
                  "show-buttons": "",
                  "button-layout": "horizontal",
                  "increment-button-icon": "pi pi-plus",
                  "decrement-button-icon": "pi pi-minus",
                  prefix: "$"
                }, null, 8, ["modelValue", "errors-map", "label", "help"]),
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.campaign.max_spending_per_endpoint_per_day,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.campaign.max_spending_per_endpoint_per_day) = $event)),
                  modelModifiers: { number: true },
                  name: "max_spending_per_endpoint_per_day",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('max_spending_per_endpoint_per_day'),
                  help: _ctx.$t('max_spending_per_endpoint_per_day_help'),
                  min: 0,
                  step: 5,
                  "show-buttons": "",
                  "button-layout": "horizontal",
                  "increment-button-icon": "pi pi-plus",
                  "decrement-button-icon": "pi pi-minus",
                  prefix: "$"
                }, null, 8, ["modelValue", "errors-map", "label", "help"]),
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.campaign.max_spending,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.campaign.max_spending) = $event)),
                  modelModifiers: { number: true },
                  name: "max_spent",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('max_spending'),
                  help: _ctx.$t('max_spending_help'),
                  min: 0,
                  step: 5,
                  "show-buttons": "",
                  "button-layout": "horizontal",
                  "increment-button-icon": "pi pi-plus",
                  "decrement-button-icon": "pi pi-minus",
                  prefix: "$"
                }, null, 8, ["modelValue", "errors-map", "label", "help"])
              ])
            ]),
            (_ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPC && _ctx.campaign.max_spending_per_day > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.max_spending_per_day_strategy,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.campaign.max_spending_per_day_strategy) = $event)),
                      modelModifiers: { number: true },
                      name: "max_spending_per_day_strategy",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('max_spending_per_day_strategy'),
                      help: _ctx.campaign.max_spending_per_day_strategy === _ctx.CAMPAIGN_MAX_SPENDING_PER_DAY_STRATEGY_FAST ? _ctx.$t('fast_help') : _ctx.$t('smoothly_help'),
                      options: _ctx.CAMPAIGN_MAX_SPENDING_PER_DAY_STRATEGIES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "errors-map", "label", "help", "options"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPA)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("h6", null, _toDisplayString(_ctx.$t('test')) + " ⚗️", 1)
                    ]),
                    (!!_ctx.campaign.id)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
                          (_ctx.campaign.test)
                            ? (_openBlock(), _createBlock(_component_PrimeVueTag, {
                                key: 0,
                                value: _ctx.$t('test_in_progess'),
                                severity: "info"
                              }, null, 8, ["value"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_PrimeVueTag, {
                                  value: _ctx.$t('test_is_done'),
                                  severity: "success"
                                }, null, 8, ["value"]),
                                (_ctx.campaign.test_is_failed)
                                  ? (_openBlock(), _createBlock(_component_PrimeVueTag, {
                                      key: 0,
                                      class: "ml-2",
                                      value: _ctx.$t('low_roi'),
                                      severity: "danger"
                                    }, null, 8, ["value"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_FieldNumber, {
                      modelValue: _ctx.campaign.test_max_spending,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.campaign.test_max_spending) = $event)),
                      modelModifiers: { number: true },
                      name: "test_max_spending",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('test_max_spending'),
                      min: 0,
                      step: 5,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus",
                      prefix: "$"
                    }, null, 8, ["modelValue", "errors-map", "label"]),
                    _createVNode(_component_FieldNumber, {
                      modelValue: _ctx.campaign.test_max_spending_per_endpoint,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.campaign.test_max_spending_per_endpoint) = $event)),
                      modelModifiers: { number: true },
                      name: "test_max_spending_per_endpoint",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('test_max_spending_per_endpoint'),
                      min: 0,
                      step: 5,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus",
                      prefix: "$"
                    }, null, 8, ["modelValue", "errors-map", "label"]),
                    _createVNode(_component_FieldNumber, {
                      modelValue: _ctx.campaign.test_max_spending_per_subid,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.campaign.test_max_spending_per_subid) = $event)),
                      modelModifiers: { number: true },
                      name: "test_max_spending_per_subid",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('test_max_spending_per_subid'),
                      min: 0,
                      step: 5,
                      "show-buttons": "",
                      "button-layout": "horizontal",
                      "increment-button-icon": "pi pi-plus",
                      "decrement-button-icon": "pi pi-minus",
                      prefix: "$"
                    }, null, 8, ["modelValue", "errors-map", "label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_FieldNumber, {
                  modelValue: _ctx.campaign.max_clicks_per_ip,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.campaign.max_clicks_per_ip) = $event)),
                  modelModifiers: { number: true },
                  name: "max_clicks_per_ip",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('max_clicks_per_ip'),
                  help: _ctx.$t('max_clicks_per_ip_help'),
                  min: 0,
                  step: 1,
                  "show-buttons": "",
                  "button-layout": "horizontal",
                  "increment-button-icon": "pi pi-plus",
                  "decrement-button-icon": "pi pi-minus"
                }, null, 8, ["modelValue", "errors-map", "label", "help"])
              ])
            ]),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("h6", null, _toDisplayString(_ctx.$t('filters')) + " 👮", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_ip_mismatch,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.campaign.filter_ip_mismatch) = $event)),
                      label: _ctx.$t('filter_ip_mismatch')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_user_agent_mismatch,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.campaign.filter_user_agent_mismatch) = $event)),
                      label: _ctx.$t('filter_user_agent_mismatch')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_referrer_mismatch,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.campaign.filter_referrer_mismatch) = $event)),
                      label: _ctx.$t('filter_referrer_mismatch')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_timezone_mismatch,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.campaign.filter_timezone_mismatch) = $event)),
                      label: _ctx.$t('filter_timezone_mismatch'),
                      help: _ctx.$t('filter_timezone_mismatch_help'),
                      disabled: ""
                    }, null, 8, ["modelValue", "label", "help"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_proxy,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.campaign.filter_proxy) = $event)),
                      label: _ctx.$t('filter_proxy')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_has_no_js,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.campaign.filter_has_no_js) = $event)),
                      label: _ctx.$t('filter_has_no_js')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_iframe,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.campaign.filter_iframe) = $event)),
                      label: _ctx.$t('filter_iframe')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_headless,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.campaign.filter_headless) = $event)),
                      label: _ctx.$t('filter_headless')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.filter_double_click,
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.campaign.filter_double_click) = $event)),
                      label: _ctx.$t('filter_double_click')
                    }, null, 8, ["modelValue", "label"]),
                    (_ctx.isPush || _ctx.isNative)
                      ? (_openBlock(), _createBlock(_component_FieldCheckbox, {
                          key: 0,
                          modelValue: _ctx.campaign.filter_click_without_impression,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.campaign.filter_click_without_impression) = $event)),
                          label: _ctx.$t('filter_click_without_impression')
                        }, null, 8, ["modelValue", "label"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_52, [
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("h6", null, _toDisplayString(_ctx.$t('options')) + " 🤹🏼", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.is_builtin,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.campaign.is_builtin) = $event)),
                      label: _ctx.$t('is_builtin_female')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.meta_refresh,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.campaign.meta_refresh) = $event)),
                      label: _ctx.$t('meta_refresh')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.adsecure,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.campaign.adsecure) = $event)),
                      label: "AdSecure"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FieldCheckbox, {
                      modelValue: _ctx.campaign.has_violations,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.campaign.has_violations) = $event)),
                      label: _ctx.$t('has_violations')
                    }, null, 8, ["modelValue", "label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.approval_status,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.campaign.approval_status) = $event)),
                  modelModifiers: { number: true },
                  name: "approval_status",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('approval_status'),
                  disabled: _ctx.user.isAffiliate(),
                  options: _ctx.CAMPAIGN_APPROVAL_STATUSES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"]),
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.status,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.campaign.status) = $event)),
                  modelModifiers: { number: true },
                  name: "status",
                  "errors-map": _ctx.campaignErrorsMap,
                  label: _ctx.$t('status'),
                  options: _ctx.CAMPAIGN_STATUSES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "errors-map", "label", "options"])
              ])
            ]),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.manager_id,
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.campaign.manager_id) = $event)),
                      modelModifiers: { number: true },
                      name: "manager_id",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('manager'),
                      loading: _ctx.managersLoading,
                      "show-clear": "",
                      filter: "",
                      options: _ctx.managers.data,
                      "option-value": "id",
                      "option-label": "compiled_name"
                    }, null, 8, ["modelValue", "errors-map", "label", "loading", "options"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createVNode(_component_FieldTextarea, {
                      modelValue: _ctx.campaign.comment,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.campaign.comment) = $event)),
                      modelModifiers: { trim: true },
                      name: "comment",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('comment')
                    }, null, 8, ["modelValue", "errors-map", "label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!_ctx.campaign.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.campaign.created_at,
                      label: _ctx.$t('created_at'),
                      disabled: ""
                    }, null, 8, ["model-value", "label"]),
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.campaign.updated_at,
                      label: _ctx.$t('updated_at'),
                      disabled: ""
                    }, null, 8, ["model-value", "label"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('targeting_settings')) + " 🎯", 1),
        _createElementVNode("div", _hoisted_65, [
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('traffic_source')), 1),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_traffic_source,
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.campaign.targeting_by_traffic_source) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_traffic_source",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES_BY_TRAFFIC_SOURCE,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('traffic_category')), 1),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_traffic_category,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.campaign.targeting_by_traffic_category) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_traffic_category",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES_BY_TRAFFIC_CATEGORY,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('countries')), 1),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_countries,
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.campaign.targeting_by_countries) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_countries",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"]),
                (_ctx.campaign.targeting_by_countries !== _ctx.TARGETING_TYPE_DISABLED)
                  ? (_openBlock(), _createBlock(_component_FieldListBox, {
                      key: 0,
                      modelValue: _ctx.campaign.countries_ids,
                      "onUpdate:modelValue": [
                        _cache[52] || (_cache[52] = ($event: any) => ((_ctx.campaign.countries_ids) = $event)),
                        _ctx.onCountriesIdsChange
                      ],
                      loading: _ctx.countriesLoading,
                      invalid: !_ctx.campaign.countries_ids.length,
                      options: _ctx.countries.data,
                      "option-value": "id",
                      "option-label": "compiled_name"
                    }, null, 8, ["modelValue", "loading", "invalid", "options", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.campaign.countries_ids.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('regions')), 1),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_regions_ids,
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.campaign.targeting_by_regions_ids) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_regions_ids",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.campaign.targeting_by_regions_ids !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_component_FieldListBox, {
                          key: 0,
                          modelValue: _ctx.campaign.regions_ids,
                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.campaign.regions_ids) = $event)),
                          loading: _ctx.regionsLoading,
                          invalid: !_ctx.campaign.regions_ids.length,
                          options: _ctx.regions.data,
                          "option-value": "id",
                          "option-label": "compiled_name"
                        }, null, 8, ["modelValue", "loading", "invalid", "options"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isPush || _ctx.isNative)
            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('languages')), 1),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_languages_codes,
                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.campaign.targeting_by_languages_codes) = $event)),
                      name: "targeting_by_languages_codes",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.campaign.targeting_by_languages_codes !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_component_FieldListBox, {
                          key: 0,
                          modelValue: _ctx.campaign.languages_codes,
                          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.campaign.languages_codes) = $event)),
                          loading: _ctx.languagesLoading,
                          invalid: !_ctx.campaign.languages_codes.length,
                          options: _ctx.languages.data,
                          "option-value": "code",
                          "option-label": "compiled_name"
                        }, null, 8, ["modelValue", "loading", "invalid", "options"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('platforms')), 1),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_platforms,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.campaign.targeting_by_platforms) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_platforms",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"]),
                (_ctx.campaign.targeting_by_platforms !== _ctx.TARGETING_TYPE_DISABLED)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, [
                          _createVNode(_component_PrimeVueButton, {
                            class: "p-button-outlined w-full",
                            label: _ctx.$t('desktop'),
                            onClick: _ctx.selectDesktopPlatforms
                          }, null, 8, ["label", "onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_87, [
                          _createVNode(_component_PrimeVueButton, {
                            class: "p-button-outlined w-full",
                            label: _ctx.$t('mobile'),
                            onClick: _ctx.selectMobilePlatforms
                          }, null, 8, ["label", "onClick"])
                        ])
                      ]),
                      _createVNode(_component_FieldListBox, {
                        modelValue: _ctx.campaign.platforms_ids,
                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.campaign.platforms_ids) = $event)),
                        loading: _ctx.platformsLoading,
                        invalid: !_ctx.campaign.platforms_ids.length,
                        options: _ctx.platforms.data,
                        "option-value": "id",
                        "option-label": "name"
                      }, null, 8, ["modelValue", "loading", "invalid", "options"])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('browsers')), 1),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_browsers,
                  "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.campaign.targeting_by_browsers) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_browsers",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"]),
                (_ctx.campaign.targeting_by_browsers !== _ctx.TARGETING_TYPE_DISABLED)
                  ? (_openBlock(), _createBlock(_component_FieldListBox, {
                      key: 0,
                      modelValue: _ctx.campaign.browsers_ids,
                      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.campaign.browsers_ids) = $event)),
                      loading: _ctx.browsersLoading,
                      invalid: !_ctx.campaign.browsers_ids.length,
                      options: _ctx.browsers.data,
                      "option-value": "id",
                      "option-label": "name"
                    }, null, 8, ["modelValue", "loading", "invalid", "options"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        (_ctx.campaign.traffic_type === _ctx.TRAFFIC_TYPE_PUSH)
          ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('subscriber_age')), 1),
                _createElementVNode("div", _hoisted_93, [
                  _createElementVNode("div", _hoisted_94, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_subscriber_age,
                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.campaign.targeting_by_subscriber_age) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_subscriber_age",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES_BY_SUBSCRIBER_AGE,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('campaign_connection_type')), 1),
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("div", _hoisted_98, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.connection_type,
                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.campaign.connection_type) = $event)),
                  modelModifiers: { number: true },
                  name: "connection_type",
                  label: _ctx.$t('campaign_connection_type'),
                  options: _ctx.CAMPAIGN_CONNECTION_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('ips')), 1),
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("div", _hoisted_101, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_ips,
                  "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.campaign.targeting_by_ips) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_ips",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"])
              ]),
              (_ctx.campaign.targeting_by_ips !== _ctx.TARGETING_TYPE_DISABLED)
                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                    _createVNode(_component_FieldTextarea, {
                      modelValue: _ctx.campaign.ips,
                      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.campaign.ips) = $event)),
                      modelModifiers: { trim: true },
                      name: "ips",
                      "errors-map": _ctx.campaignErrorsMap,
                      label: _ctx.$t('ips'),
                      help: _ctx.$t('ips_help'),
                      invalid: !_ctx.campaign.ips.length
                    }, null, 8, ["modelValue", "errors-map", "label", "help", "invalid"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('carriers')), 1),
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("div", _hoisted_105, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_carriers_ids,
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.campaign.targeting_by_carriers_ids) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_carriers_ids",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"])
              ]),
              (_ctx.campaign.targeting_by_carriers_ids !== _ctx.TARGETING_TYPE_DISABLED)
                ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                    _createVNode(_component_FieldListBox, {
                      modelValue: _ctx.campaign.carriers_ids,
                      "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.campaign.carriers_ids) = $event)),
                      loading: _ctx.carriersLoading,
                      invalid: !_ctx.campaign.carriers_ids.length,
                      options: _ctx.carriers.data,
                      "option-value": "id",
                      "option-label": "compiled_name"
                    }, null, 8, ["modelValue", "loading", "invalid", "options"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_107, [
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('endpoints')), 1),
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("div", _hoisted_110, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_endpoints_ids,
                      "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.campaign.targeting_by_endpoints_ids) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_endpoints_ids",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.campaign.targeting_by_endpoints_ids !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_component_FieldListBox, {
                          key: 0,
                          modelValue: _ctx.campaign.endpoints_ids,
                          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.campaign.endpoints_ids) = $event)),
                          name: "endpoints_ids",
                          "errors-map": _ctx.campaignErrorsMap,
                          label: _ctx.$t('endpoints'),
                          loading: _ctx.endpointsLoading,
                          invalid: !_ctx.campaign.endpoints_ids.length,
                          options: _ctx.endpoints.data,
                          "option-value": "id",
                          "option-label": "compiled_name"
                        }, null, 8, ["modelValue", "errors-map", "label", "loading", "invalid", "options"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_111, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('zones_uids')), 1),
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("div", _hoisted_113, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_endpoints_uids,
                  "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.campaign.targeting_by_endpoints_uids) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_endpoints_uids",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"]),
                (_ctx.campaign.targeting_by_endpoints_uids !== _ctx.TARGETING_TYPE_DISABLED)
                  ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TargetingByValues, {
                          modelValue: _ctx.campaign.endpoints_uids,
                          "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.campaign.endpoints_uids) = $event)),
                          "allow-int": "",
                          title: _ctx.$t('zones_uids'),
                          help: _ctx.$t('zones_uids_help')
                        }, null, 8, ["modelValue", "title", "help"])
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('referrers_hosts')), 1),
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("div", _hoisted_116, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.campaign.targeting_by_referrers_hosts,
                      "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.campaign.targeting_by_referrers_hosts) = $event)),
                      modelModifiers: { number: true },
                      name: "targeting_by_referrers_hosts",
                      label: _ctx.$t('targeting_type'),
                      options: _ctx.TARGETING_TYPES,
                      "option-label-translate": ""
                    }, null, 8, ["modelValue", "label", "options"]),
                    (_ctx.campaign.targeting_by_referrers_hosts !== _ctx.TARGETING_TYPE_DISABLED)
                      ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TargetingByValues, {
                              modelValue: _ctx.campaign.referrers_hosts,
                              "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.campaign.referrers_hosts) = $event)),
                              "allow-any": "",
                              title: _ctx.$t('referrers_hosts'),
                              help: _ctx.$t('referrers_hosts_help')
                            }, null, 8, ["modelValue", "title", "help"])
                          ]),
                          fallback: _withCtx(() => [
                            _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('subids_uuids')), 1),
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", _hoisted_119, [
                (_ctx.user.isStaff())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_FieldCheckbox, {
                        modelValue: _ctx.campaign.use_quality_presets,
                        "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.campaign.use_quality_presets) = $event)),
                        label: _ctx.$t('use_quality_presets')
                      }, null, 8, ["modelValue", "label"]),
                      (_ctx.campaign.use_quality_presets)
                        ? (_openBlock(), _createBlock(_component_FieldListBox, {
                            key: 0,
                            modelValue: _ctx.campaign.quality_presets_ids,
                            "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.campaign.quality_presets_ids) = $event)),
                            name: "quality_presets_ids",
                            "errors-map": _ctx.campaignErrorsMap,
                            label: _ctx.$t('quality_presets'),
                            loading: _ctx.qualityPresetsLoading,
                            invalid: !_ctx.campaign.quality_presets_ids.length,
                            options: _ctx.qualityPresets.data,
                            "option-value": "id",
                            "option-label": "compiled_name"
                          }, null, 8, ["modelValue", "errors-map", "label", "loading", "invalid", "options"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.campaign.targeting_by_subids,
                  "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.campaign.targeting_by_subids) = $event)),
                  modelModifiers: { number: true },
                  name: "targeting_by_subids",
                  label: _ctx.$t('targeting_type'),
                  options: _ctx.TARGETING_TYPES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "label", "options"]),
                (_ctx.campaign.targeting_by_subids !== _ctx.TARGETING_TYPE_DISABLED)
                  ? (_openBlock(), _createBlock(_Suspense, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TargetingByValues, {
                          modelValue: _ctx.campaign.subids_uuids,
                          "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.campaign.subids_uuids) = $event)),
                          "allow-uuid": "",
                          title: _ctx.$t('subids_uuids'),
                          help: _ctx.$t('subids_uuids_help')
                        }, null, 8, ["modelValue", "title", "help"])
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_120, [
          _createElementVNode("div", _hoisted_121, [
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_ScheduleByHours, {
                  modelValue: _ctx.campaign.hours,
                  "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.campaign.hours) = $event)),
                  "hide-schedule": _ctx.campaign.targeting_by_hours === _ctx.TARGETING_TYPE_DISABLED
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_122, [
                      _createVNode(_component_FieldDropdownNext, {
                        modelValue: _ctx.campaign.targeting_by_hours,
                        "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.campaign.targeting_by_hours) = $event)),
                        modelModifiers: { number: true },
                        name: "targeting_by_hours",
                        label: _ctx.$t('targeting_type'),
                        options: _ctx.TARGETING_TYPES,
                        "option-label-translate": ""
                      }, null, 8, ["modelValue", "label", "options"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "hide-schedule"])
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
              ]),
              _: 1
            }))
          ]),
          _createElementVNode("div", _hoisted_123, [
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_ScheduleByDays, {
                  modelValue: _ctx.campaign.days,
                  "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.campaign.days) = $event)),
                  "hide-schedule": _ctx.campaign.targeting_by_days === _ctx.TARGETING_TYPE_DISABLED
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_124, [
                      _createVNode(_component_FieldDropdownNext, {
                        modelValue: _ctx.campaign.targeting_by_days,
                        "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.campaign.targeting_by_days) = $event)),
                        modelModifiers: { number: true },
                        name: "targeting_by_days",
                        label: _ctx.$t('targeting_type'),
                        options: _ctx.TARGETING_TYPES,
                        "option-label-translate": ""
                      }, null, 8, ["modelValue", "label", "options"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "hide-schedule"])
              ]),
              fallback: _withCtx(() => [
                _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
              ]),
              _: 1
            }))
          ])
        ]),
        (!!_ctx.campaign.id && _ctx.user.isStaff())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_125,
              _createElementVNode("div", _hoisted_126, [
                _createElementVNode("div", _hoisted_127, [
                  (_openBlock(), _createBlock(_Suspense, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_AdSecure, {
                        filters: { campaign_id: _ctx.campaign.id },
                        "show-relations-columns": false
                      }, null, 8, ["filters"])
                    ]),
                    fallback: _withCtx(() => [
                      _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                    ]),
                    _: 1
                  }))
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "entry", "entry-errors-map", "entry-fetch-handler", "entry-store-handler"])
  ], 64))
}